import { useEffect, useState } from "react";
import { getDevices, DeviceRecord } from "../lib/fleet-state";
import StatusDot from "../components/StatusDot";
import { PanelScroll } from "./ClientsPanel";

export default function DevicesPanel() {
  const [devices, setDevices] = useState<DeviceRecord[]>([]);
  useEffect(() => { getDevices().then(setDevices).catch(() => setDevices([])); }, []);
  const groups: Record<string, DeviceRecord[]> = { primary: [], sidecar: [], stationary: [] };
  for (const d of devices) groups[d.category]?.push(d);
  return (
    <PanelScroll accentVar="--biome-tech" title="Devices" subtitle="the SAGE mesh">
      {Object.entries(groups).map(([cat, list]) => list.length > 0 && (
        <div key={cat}>
          <div className="text-caption uppercase tracking-wide text-text-dim mb-2">{cat}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {list.map((d) => (
              <div key={d.name} className="rounded-xl border bg-surface p-3 hover:bg-surface-hover transition-colors">
                <div className="flex items-center gap-2">
                  <StatusDot health={d.reachable ? "green" : "red"} />
                  <span className="font-serif font-bold text-text">{d.name}</span>
                  {d.ip && <span className="text-caption text-text-dim font-mono ml-auto">{d.ip}</span>}
                </div>
                <div className="text-body-sm text-text-muted mt-1">{d.role}</div>
                {d.archetype && <div className="text-caption text-text-dim mt-1">archetype: {d.archetype}</div>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </PanelScroll>
  );
}
